<template>
  <div>

    <vue-topprogress ref="loadingProgress"></vue-topprogress>

    <div class="animated fadeIn" v-if="!loading">

      <h1 class="display-4 font-weight-lighter mb-4">My Account</h1>

      <b-tabs>

        <b-tab title="Company Information" active>
          <div class="pt-3">
            <b-alert v-if="validation && validation.customer_expired" show>Your company information is expired, please review and save to continue.</b-alert>
            <b-alert v-if="validation && validation.customer_incomplete.length" show v-html="validation ? validation.customer_incomplete.join('<br />') : ''"></b-alert>
            <customer-form :customer="validation.customer" @onSaved="savedCustomer" save_label="Save and Continue"></customer-form>
          </div>
        </b-tab>

        <b-tab title="Company Address">
          <div class="pt-3">
            <b-alert v-if="validation && (validation.shipping_address_expired || validation.billing_address_expired)" show>Your company address is expired, please review and save to continue.</b-alert>
            <b-alert v-if="validation && validation.shipping_address_incomplete.length" show v-html="validation ? validation.shipping_address_incomplete.join('<br />') : ''"></b-alert>
            <b-alert v-if="validation && validation.billing_address_incomplete.length" show v-html="validation ? validation.billing_address_incomplete.join('<br />') : ''"></b-alert>
            <customer-location-form 
              :shipping_address="validation.shipping_address" 
              :billing_address="validation.billing_address" 
              @change="fillAddresses"
            ></customer-location-form>
            <div class="clearfix"><div class="d-inline-block float-right">
              <b-overlay :show="saving" spinner-small>
                  <b-button squared variant="sf" @click="saveAddresses">Save and Continue</b-button>
              </b-overlay>
            </div></div>
          </div>
        </b-tab>

        <b-tab title="Accounting Contact">
          <div class="pt-3">
            <b-alert v-if="validation && validation.accounting_contact_expired" show>Your accounting contact is expired, please review and save to continue.</b-alert>
            <b-alert v-if="validation && validation.accounting_contact_incomplete.length" show v-html="validation ? validation.accounting_contact_incomplete.join('<br />') : ''"></b-alert>
            <contact-edit-form :contact="validation.accounting_contact" :hide_fields="{type:true}" :commit="false" @change="i=>(form.accounting_contact={...validation.accounting_contact,...i})"></contact-edit-form>
            <div class="clearfix"><div class="d-inline-block float-right">
              <b-overlay :show="saving" spinner-small>
                  <b-button squared variant="sf" @click="saveAccountingContact">Save and Continue</b-button>
              </b-overlay>
            </div></div>
          </div>
        </b-tab>

        <b-tab title="Active User(s)">
          <div class="mt-3"></div>
          <!-- <div class="clearfix"><b-button squared variant="sf" class="float-right" @click="contact_modal = true"><i class="fal fa-plus"></i> New</b-button></div> -->
          <!-- <br /> -->
          <c-row v-if="customer_contacts.filter(i=>!!i.user).length">
            <template v-for="customer_contact in customer_contacts.filter(i=>!!i.user)">
              <c-col cols="12" md="4" v-if="customer_contact && customer_contact.contact" class="mb-4" :key="customer_contact.id">
                <contact-card
                  :customer_contact="customer_contact"
                  @customerContactChange="updated_customer_contact => updateCustomerContact(updated_customer_contact, customer_contact.id)"
                  @onDelete="deleted_customer_contact => deleteCustomerContact(deleted_customer_contact, customer_contact.id)"
                ></contact-card>
              </c-col>
            </template>
          </c-row>
          <b-alert v-else show>No additional users.</b-alert>
        </b-tab>

        <b-tab title="Pending User(s)">
          <div class="mt-3"></div>
          <b-alert show>These contacts are associationed with your company, but have not yet been invited to login.</b-alert>
          <div class="clearfix"><b-button squared variant="sf" class="float-right" @click="contact_modal = true"><i class="fal fa-plus"></i> New</b-button></div>
          <br />
          <c-row v-if="customer_contacts.filter(i=>!i.user).length">
            <template v-for="customer_contact in customer_contacts.filter(i=>!i.user)">
              <c-col cols="12" md="4" v-if="customer_contact && customer_contact.contact" class="mb-4" :key="customer_contact.id">
                <contact-card
                  :customer_contact="customer_contact"
                  @customerContactChange="updated_customer_contact => updateCustomerContact(updated_customer_contact, customer_contact.id)"
                  @onDelete="deleted_customer_contact => deleteCustomerContact(deleted_customer_contact, customer_contact.id)"
                ></contact-card>
              </c-col>
            </template>
          </c-row>
          <b-alert v-else show>No additional contacts.</b-alert>
        </b-tab>
      
      </b-tabs>
      
      <CModal size="lg" title="Invite New User" :show.sync="contact_modal">
        <contact-form
          @cancel="contact_modal = false"
          @onSave="(new_customer_contact, new_contact) => {updateCustomerContact(new_customer_contact); contact_modal = false;}"
          @onSaveFail="saveFail"
        ></contact-form>
        <template v-slot:footer-wrapper><div></div></template>
      </CModal>

    </div>

  </div>
</template>

<script>
import ContactCard from '../components/customers/contacts/ContactCard.vue';
import ContactEditForm from '../components/customers/contacts/ContactEditForm.vue';
import CustomerForm from '../components/customers/CustomerForm.vue';
import CustomerLocationForm from '../components/customers/locations/CustomerLocationForm.vue';
import ContactForm from '../components/order/form/ContactForm.vue';
import ToastNotifications from '../components/shared/mixins/ToastNotifications';
import CustomerContact from '../models/CustomerContact';
export default {
  name: 'AccountDashboard',
  mixins: [ToastNotifications],
  components: {CustomerForm, CustomerLocationForm, ContactEditForm, ContactForm, ContactCard},
  data() {
    return {
      loading: true,
      saving: false,
      validation: null,
      form: {
        shipping_address: null,
        billing_address: null,
        accounting_contact: null
      },
      customer_contacts: [],
      contact_modal: false
    }
  },
  computed: {},
  methods: {
    fillAddresses(payload) {
      let billing = payload.billing_address;
      let keys = ['street_address','city','region','country','postal'];
      let shipping_address = Object.fromEntries(keys.map(k=>[k,payload[k]]));
      let billing_address = Object.fromEntries(keys.map(k=>[k,payload[k]]));
      billing_address.street_address = billing;
      shipping_address.name = 'Shipping Address';
      billing_address.name = 'Billing Address';
      this.form.shipping_address = {...this.form.shipping_address, ...shipping_address};
      this.form.billing_address = {...this.form.billing_address, ...billing_address};
    },
    saveAddresses() {
      this.saving = true;
      let customer = Customer.find(this.$store.getters.getAuthCustomerID);
      return Promise.all([
        CustomerLocationRepository.updateOrCreateLocation(customer, this.form.shipping_address),
        CustomerLocationRepository.updateOrCreateLocation(customer, this.form.billing_address)
      ]).then(() => {
          this.saving = false;
          this.isValid.shipping_address = true;
          this.isValid.billing_address = true;
          this.checkValidation();
      });
    },
    saveAccountingContact() {
      this.saving = true;
      let customer = Customer.find(this.$store.getters.getAuthCustomerID);
      return CustomerContactRepository.updateOrCreateContact(customer, this.form.accounting_contact).then(() => {
          this.saving = false;
          this.isValid.accounting_contact = true;
          this.checkValidation();
      });
    },
    updateCustomerContact(item, id) {
      let index = id ? this.customer_contacts.findIndex(i=>+(i.id)===+(id)) : -1;
      if(index !== -1) {
        this.customer_contacts.splice(index, 1, item);
      } else {
        this.customer_contacts.push(item);
      }
    },
    deleteCustomerContact(item, id) {
      let index = id ? this.customer_contacts.findIndex(i=>+(i.id)===+(id)) : -1;
      if(index !== -1) {
        this.customer_contacts.splice(index, 1);
      }
    }
  },
  async mounted() {
    this.loading = true;
    this.$refs.loadingProgress.start();
    this.validation = await this.$store.dispatch('AUTH_VALIDATE_CUSTOMER');
    this.validation.customer_contacts.forEach(i => {
      let customer_contact = CustomerContact.query().where('id', +(i.customer_contact.id)).with(['contact','location','user']).first();
      if(customer_contact) {
        this.customer_contacts.push(customer_contact);
      }
    });
    this.$refs.loadingProgress.done();
    this.loading = false;
  }
}
</script>
